<virtual-binder [isSession]="true"></virtual-binder>
